<template>
    <div class="main">
        <!-- 头部搜索区域 -->
        <global-tag>
            <span slot="title">残疾人</span>
            <div class="search" slot="search">
                <el-form label-width="120px" :model="queryInfo">
                    <div class="searchBox">
                        <div class="content">
                            <el-row>
                                <el-col :span="5">
                                    <el-form-item label="姓名：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.personName"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="性别：">
                                        <el-select
                                            style="width: 100%"
                                            v-model="queryInfo.sex"
                                            placeholder="请选择"
                                        >
                                            <el-option
                                                label="男"
                                                value="1"
                                            ></el-option>
                                            <el-option
                                                label="女"
                                                value="2"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item label="联系方式：">
                                        <el-input
                                            clearable
                                            v-model.trim="queryInfo.phone"
                                            style="width: 100%"
                                            placeholder="请输入"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="btn">
                            <el-button type="primary" @click="querySearch"  class="searchBtns"
                                >查询</el-button
                            >
                        </div>
                    </div>
                </el-form>
            </div>
        </global-tag>
        <!-- 搜索区域结束 -->
        <!-- 新增按钮区域 -->
        <div class="table_title">
            <div class="btn_group">
                <el-button
                    type="success"
                     icon="el-icon-plus"
            class="openBtns"
                    size="medium"
                    @click="addServices('新增', 'add')"
                    >新增</el-button
                >
                <el-button
                    type="primary"
                    icon="el-icon-download" class="button downOutBtns"
                    size="medium"
                    @click="createExcel"
                    >导出数据</el-button
                >
                <div style="display: none">
                    <input @change="fileChange" id="speechUpload" type="file" />
                </div>
                <label for="speechUpload" class="labelImportBtn inDwonBtns">
         
          <span> <i class="el-icon-upload2"></i>导入数据</span>
        </label>
                <el-button
                    type="warning"
                     icon="el-icon-sold-out" class="button modelDownds"
                    size="medium"
                    @click="downExcel"
                    >下载模板</el-button
                >
            </div>
            <!-- 筛选按钮 -->
            <div class="screen_container">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-refresh"
                        class="dropRests"
                        @click="reset"
                    ></el-button>
                    <!-- <el-button type="primary" style="padding: 10px 20px"> -->
                        <el-dropdown trigger="click" :hide-on-click="false" class="dropdown1">
                            <span class="el-dropdown-link">
                                <i
                                    class="el-icon-s-grid el-icon--right"
                                    style="color: #fff"
                                ></i>
                                <i
                                    class="el-icon-arrow-down el-icon--right"
                                ></i>
                            </span>
                            <el-dropdown-menu
                                slot="dropdown"
                                class="table_checkbox"
                            >
                                <el-dropdown-item>
                                    <el-checkbox-group
                                        v-model="tableChekbox"
                                        @change="tableChekboxChange"
                                    >
                                        <el-checkbox label="姓名"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="身份证号"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="联系电话"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="户籍地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="人员类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="人口类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="性别"></el-checkbox
                                        ><br />
                                        <el-checkbox label="民族"></el-checkbox
                                        ><br />
                                        <el-checkbox label="学历"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="政治面貌"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="婚姻状况"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="与房主关系"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾类型"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾等级"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾人证"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾车_车牌号码"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="收入情况_详细情况"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="住房来源"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="一户多残"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="老养残"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾状况"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾日期"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="残疾原因"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="劳动能力"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="技能特长"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="办证日期"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="监护人_公民身份证"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="监护人_公民姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="监护人_联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="配偶_公民身份证号"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="配偶_姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="配偶_联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="申请人_公民身份证号码"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="申请人_姓名"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="申请人_联系电话"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="备注"></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="标准地址"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="点位坐标"
                                        ></el-checkbox
                                        ><br />

                                        <el-checkbox
                                            label="创建时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑时间"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="创建人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox
                                            label="最后编辑人"
                                        ></el-checkbox
                                        ><br />
                                        <el-checkbox label="操作"></el-checkbox
                                        ><br />
                                    </el-checkbox-group>
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    <!-- </el-button> -->
                </el-button-group>
            </div>
        </div>
        <!-- 主页表格区域 -->
        <div class="table_container">
            <el-table
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                height="300px"
                ref="multipleTable"
                :header-cell-style="{ background: '#e6e6e6', color: '#000' }"
                border
            >
                <el-table-column
                    type="index"
                    width="60"
                    label="序号"
                    align="center"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '序号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="姓名"
                    min-width="100px"
                    align="center"
                    prop="personName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="身份证号"
                    min-width="140px"
                    align="center"
                    prop="idCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '身份证号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="联系电话"
                    min-width="120px"
                    align="center"
                    prop="phone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="户籍地址"
                    min-width="230px"
                    align="center"
                    prop="originPlace"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '户籍地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="人员类型"
                    min-width="150px"
                    align="center"
                    prop="personnelType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '人员类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.personnelType == 0"
                            >常住人口</span
                        >
                        <span v-if="scope.row.personnelType == 1">出租</span>
                        <span v-if="scope.row.personnelType == 2">流动</span>
                        <span v-if="scope.row.personnelType == 3">空房</span>
                        <span v-if="scope.row.personnelType == 4">境外</span>
                        <span v-if="scope.row.personnelType == 5">未落户</span>
                        <span v-if="scope.row.personnelType == 6">商房</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="人口类型"
                    min-width="150px"
                    align="center"
                    prop="populationType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '人口类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.populationType == 1"
                            >本地户籍人口</span
                        >
                        <span v-if="scope.row.populationType == 2"
                            >外地户籍人口</span
                        >
                        <span v-if="scope.row.populationType == 3">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="性别"
                    align="center"
                    min-width="90px"
                    prop="sex"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '性别'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.sex == 1">男</span>
                        <span v-if="scope.row.sex == 2">女</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="民族"
                    align="center"
                    min-width="80px"
                    prop="nation"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '民族'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="学历"
                    min-width="100px"
                    align="center"
                    prop="education"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '学历'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.education == 1">小学</span>
                        <span v-if="scope.row.education == 2">初中</span
                        ><span v-if="scope.row.education == 2">初中</span>
                        <span v-if="scope.row.education == 3">高中</span>
                        <span v-if="scope.row.education == 4">职校</span>
                        <span v-if="scope.row.education == 5">专科</span>
                        <span v-if="scope.row.education == 6">本科</span>
                        <span v-if="scope.row.education == 7">硕士</span>
                        <span v-if="scope.row.education == 8">博士</span>
                        <span v-if="scope.row.education == 9">暂无数据</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="政治面貌"
                    min-width="110px"
                    align="center"
                    prop="partyType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '政治面貌'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.partyType == 0">中共党员</span>
                        <span v-if="scope.row.partyType == 1">共青团员</span>
                        <span v-if="scope.row.partyType == 2">群众</span>
                        <span v-if="scope.row.partyType == 3">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="婚姻状况"
                    align="center"
                    min-width="100px"
                    prop="maritalStatus"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '婚姻状况'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.maritalStatus == 1">未婚</span>
                        <span v-if="scope.row.maritalStatus == 2">已婚</span>
                        <span v-if="scope.row.maritalStatus == 3">离婚</span>
                        <span v-if="scope.row.maritalStatus == 4">丧偶</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="与户主关系"
                    align="center"
                    min-width="100px"
                    prop="relationship"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '健康状况'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.relationship == 1001">本人</span>
                        <span v-if="scope.row.relationship == 1002">夫妻</span>
                        <span v-if="scope.row.relationship == 1003">父亲</span>
                        <span v-if="scope.row.relationship == 1004">母亲</span>
                        <span v-if="scope.row.relationship == 1005">岳父</span>
                        <span v-if="scope.row.relationship == 1006">岳母</span>
                        <span v-if="scope.row.relationship == 1007">长子</span>
                        <span v-if="scope.row.relationship == 1008">次子</span>
                        <span v-if="scope.row.relationship == 1009">长女</span>
                        <span v-if="scope.row.relationship == 1010">次女</span>
                        <span v-if="scope.row.relationship == 1011">其他</span>
                        <span v-if="scope.row.relationship == 1012">儿媳</span>
                        <span v-if="scope.row.relationship == 1013">孙子</span>
                        <span v-if="scope.row.relationship == 1014">孙女</span>
                        <span v-if="scope.row.relationship == 1015">女婿</span>
                        <span v-if="scope.row.relationship == 1016">租户</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="残疾类型"
                    align="center"
                    min-width="100px"
                    prop="disabilityType"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾类型'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.disabilityType == 1">智力</span>
                        <span v-if="scope.row.disabilityType == 2">身体</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="残疾等级"
                    align="center"
                    min-width="100px"
                    prop="disabilityGrade"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾等级'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.disabilityType == 1">一级</span>
                        <span v-if="scope.row.disabilityType == 2">二级</span>
                        <span v-if="scope.row.disabilityType == 3">二级</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="残疾人证"
                    align="center"
                    min-width="180px"
                    prop="disabilityCertificate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾人证'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="残疾车_车牌号码"
                    align="center"
                    min-width="160px"
                    prop="disabilityLicenseNumbe"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾车_车牌号码'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="收入情况_详细情况"
                    align="center"
                    min-width="160px"
                    prop="income"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '收入情况_详细情况'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="住房来源"
                    align="center"
                    min-width="100px"
                    prop="housingSource"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '住房来源'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.housingSource == 1">自购</span>
                        <span v-if="scope.row.housingSource == 2">租用</span>
                        <span v-if="scope.row.housingSource == 3">贷款</span>
                        <span v-if="scope.row.housingSource == 4">其他</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="一户多残"
                    align="center"
                    min-width="100px"
                    prop="thanMore"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '一户多残'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.thanMore == 0">否</span>
                        <span v-if="scope.row.thanMore == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="老养残"
                    align="center"
                    min-width="100px"
                    prop="oldResidual"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '老养残'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.oldResidual == 0">否</span>
                        <span v-if="scope.row.oldResidual == 1">是</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="残疾状况"
                    align="center"
                    min-width="100px"
                    prop="disability"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾状况'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.disability == 1">智残</span>
                        <span v-if="scope.row.disability == 2">身残</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="残疾日期"
                    align="center"
                    min-width="160px"
                    prop="disabilityDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="残疾原因"
                    align="center"
                    min-width="160px"
                    prop="disabilityReason"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '残疾原因'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="劳动能力"
                    align="center"
                    min-width="100px"
                    prop="laborCapacity"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '劳动能力'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.laborCapacity == 0">无</span>
                        <span v-if="scope.row.laborCapacity == 1">有</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="技能特长"
                    align="center"
                    min-width="100px"
                    prop="specialty"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '技能特长'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="办证日期"
                    align="center"
                    min-width="160px"
                    prop="registrationDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '办证日期'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="监护人_公民身份证"
                    align="center"
                    min-width="230px"
                    prop="guardianIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '监护人_公民身份证'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="监护人_公民姓名"
                    align="center"
                    min-width="140px"
                    prop="guardianName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '监护人_公民姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="监护人_联系电话"
                    align="center"
                    min-width="160px"
                    prop="guardianPhone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '监护人_联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="配偶_公民身份证号"
                    align="center"
                    min-width="230px"
                    prop="spouseIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '配偶_公民身份证号'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="配偶_姓名"
                    align="center"
                    min-width="130px"
                    prop="spouseName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '配偶_姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="配偶_联系电话"
                    align="center"
                    min-width="160px"
                    prop="spousePhone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '配偶_联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="申请人_公民身份证号码"
                    align="center"
                    min-width="230px"
                    prop="applicantIdCard"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '申请人_公民身份证号码'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="申请人_姓名"
                    align="center"
                    min-width="120px"
                    prop="applicantName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '申请人_姓名'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="申请人_联系电话"
                    align="center"
                    min-width="160px"
                    prop="applicantPhone"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '申请人_联系电话'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="备注"
                    align="center"
                    min-width="140px"
                    prop="remark"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '备注'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="标准地址"
                    align="center"
                    min-width="230px"
                    prop="address"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '标准地址'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="点位坐标"
                    align="center"
                    min-width="230px"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '点位坐标'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <span>
                            经度：{{ scope.row.longitude }}纬度：{{
                                scope.row.latitude
                            }}</span
                        >
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建时间"
                    align="center"
                    min-width="180px"
                    prop="createDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑时间"
                    align="center"
                    min-width="180px"
                    prop="updateDate"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑时间'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="创建人"
                    align="center"
                    min-width="100px"
                    prop="createPersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '创建人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="最后编辑人"
                    align="center"
                    min-width="100px"
                    prop="updatePersonName"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '最后编辑人'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    min-width="240px"
                    fixed="right"
                    v-if="
                        this.tempTableChekbox.findIndex(
                            (item) => item == '操作'
                        ) != -1
                    "
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <div>
                            <span
                                @click="addServices('详情', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看</span
                            >
                            <span
                                @click="addServices('编辑', scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >编辑</span
                            >
                            <span
                                @click="seeMap(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >查看地图定位</span
                            >
                            <!-- <span
                                @click="goSee(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >走访处理</span
                            > -->
                            <span
                                @click="deleteItem(scope.row)"
                                style="margin-right: 12px; cursor: pointer"
                                >删除</span
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination
            @size-change="handletableDataSize"
            @current-change="handleTableDataChange"
            :page-sizes="[10, 20, 40, 100]"
            :page-size="pageOne.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageOne.total"
        ></el-pagination>
        <!-- 主页表格区域结束 -->
        <add-service
            v-if="serviceState"
            :openData="serviceInfo"
            @cancleService="cancleService"
        ></add-service>
        <map-info
            v-if="mapState"
            :openData="mapInfo"
            @cancleService="cancleService"
        ></map-info>
    </div>
</template>
<script>
import globalTag from "./components/globalTag"
import request from "@/utils/request.js"
import addService from "./components/addService"
import mapInfo from "@/components/mapInfo"
export default {
    name: "serviceMange",
    inject: ["reload"], //注入
    components: { globalTag, addService, mapInfo },
    data() {
        return {
            serviceState: false,
            serviceInfo: {},
            mapState: false,
            mapInfo: {},
            pageOne: { total: 0, pageSize: 10, pageNo: 1 },
            tableData: [],
            queryInfo: { sex: "", personName: "", phone: "" },
            tempTableChekbox: [
                "序号",
                "姓名",
                "身份证号",
                "联系电话",
                "户籍地址",
                "人员类型",
                "人口类型",
                "性别",
                "民族",
                "学历",
                "政治面貌",
                "婚姻状况",
                "与房主关系",
                "残疾类型",
                "残疾等级",
                "残疾人证",
                "残疾车_车牌号码",
                "收入情况_详细情况",
                "住房来源",
                "一户多残",
                "老养残",
                "残疾状况",
                "残疾日期",
                "残疾原因",
                "劳动能力",
                "技能特长",
                "办证日期",
                "监护人_公民身份证",
                "监护人_公民姓名",
                "监护人_联系电话",
                "配偶_公民身份证号",
                "配偶_姓名",
                "配偶_联系电话",
                "申请人_公民身份证号码",
                "申请人_姓名",
                "申请人_联系电话",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
            tableChekbox: [
                "序号",
                "姓名",
                "身份证号",
                "联系电话",
                "户籍地址",
                "人员类型",
                "人口类型",
                "性别",
                "民族",
                "学历",
                "政治面貌",
                "婚姻状况",
                "与房主关系",
                "残疾类型",
                "残疾等级",
                "残疾人证",
                "残疾车_车牌号码",
                "收入情况_详细情况",
                "住房来源",
                "一户多残",
                "老养残",
                "残疾状况",
                "残疾日期",
                "残疾原因",
                "劳动能力",
                "技能特长",
                "办证日期",
                "监护人_公民身份证",
                "监护人_公民姓名",
                "监护人_联系电话",
                "配偶_公民身份证号",
                "配偶_姓名",
                "配偶_联系电话",
                "申请人_公民身份证号码",
                "申请人_姓名",
                "申请人_联系电话",
                "备注",
                "标准地址",
                "点位坐标",

                "创建时间",
                "最后编辑时间",
                "创建人",
                "最后编辑人",
                "操作",
            ],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 新增\编辑\查看
        addServices(title, row) {
            this.serviceState = true

            this.serviceInfo = {}
            this.serviceInfo = {
                title: title,
                id: title == "新增" ? "" : row.id,
                state: true,
            }
        },
        // 取消新增、编辑、查看
        cancleService(state) {
            this.serviceState = false
            this.mapState = false
            if (state == true) {
                this.getList()
            }
        },
        // 当前页
        handleTableDataChange(val) {
            this.pageOne.pageNo = val
            this.getList()
        },
        // 分页大小
        handletableDataSize(val) {
            this.pageOne.pageSize = val
            this.getList()
        },
        // 获取数据

        // 选择列的展示方式
        tableChekboxChange(val) {
            this.tempTableChekbox = val.map((item) => item)
        },
        // 页面刷新
        reset() {
            this.reload()
        },
        // 获取数据
        getList() {
            let params = {
                pageNo: this.pageOne.pageNo,
                pageSize: this.pageOne.pageSize,
                personName: this.queryInfo.personName,
                phone: this.queryInfo.phone,
                sex: this.queryInfo.sex,
            }
            this.$http
                .request({
                    url: "/ypt/admin/disabledPeople/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.pageOne.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.pageOne.total = res.content.count
                    }
                })
        },
        //删除表格信息
        deleteItem(date) {
            let params = {
                id: date.id,
            }
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/ypt/admin/disabledPeople/info/deleteById",
                        method: "POST",
                        data: params,
                    })
                    .then((res) => {
                        if (res.code === 200) {
                            this.$message.success(res.message)
                            // this.tableData = [];
                            this.getList()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
            })
        },
        // 查看定位
        seeMap(row) {
            this.mapState = true
            this.mapInfo = {
                address: row.address,
                longitude: row.longitude,
                latitude: row.latitude,
                provinceId: row.provinceId,
                cityId: row.cityId,
                zoneId: row.zoneId,
                streetId: row.streetId,
                shequId: row.shequId,
                id: row.id,
                state: true,
            }
        },

        // 搜索
        querySearch() {
            this.getList()
        },
        // 下载模板
        async downExcel() {
            const res = await this.request2({
                url: "/ypt/admin/disabledPeople/info/downloadExcel",
                method: "POST",
                data: {
                    postName: "*",
                },
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "残疾人.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        //导出excel
        async createExcel() {
            const res = await this.request2({
                url: "/ypt/admin/disabledPeople/info/downloadExcel",
                method: "POST",
                data: {},
                responseType: "blob",
            })
            const blob = new Blob([res], { type: "application/vnd.ms-excel" })
            const fileName = "残疾人.xls"
            const linkNode = document.createElement("a")

            linkNode.download = fileName //a标签的download属性规定下载文件的名称
            linkNode.style.display = "none"
            linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
            document.body.appendChild(linkNode)
            linkNode.click() //模拟在按钮上的一次鼠标单击

            URL.revokeObjectURL(linkNode.href) // 释放URL 对象
            document.body.removeChild(linkNode)
        },
        // 导入
        async fileChange(event) {
            console.log(event)
            const file = event.target.files[0]
            console.log(file)
            const personType = "1"
            let config = {
                headers: { "Content-Type": "multipart/form-data" },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            console.log(formData)
            formData.append("file", file)
            let result = await this.$http.post(
                "/ypt/admin/disabledPeople/info/excel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code == 200) {
                this.$message.success(result.message)
                this.getList()
            } else {
                this.$message.warning(result.message)
            }
        },
    },
}
</script>
<style lang="less" scoped>
.searchBox {
    display: flex;
    .content {
        flex: 1;
    }
}
/deep/.table_title {
    margin-top: 15px !important;
}
/deep/.btn_group {
    margin-top: 0px !important;
}
.button {
    margin-bottom: 4px;
}
.labelImportBtn {
    background: orange;
    border-radius: 3px;
    cursor: pointer;
    margin: 0 10px;
    font-size: 14px;
    padding: 3px 21px;
    color: #fff;
    line-height: 30px;
    display: inline-block;
}
.operBtn {
    cursor: pointer;
    margin-left: 10px;
}
</style>